<template>
  <div v-if="doc.busyLoadingDetails">
    <b-icon icon="loading" size="is-small" custom-class="mdi-spin"></b-icon>
    Loading...
  </div>
  <div v-else-if="doc.errorLoadingDetails" class="no-data-error">
    <b-icon icon="google-downasaur" size="is-medium"></b-icon>
    Error loading details
  </div>
  <div v-else class="detail-list">
    <div class="columns">
      <div class="column is-one-fifth label">
        Filename
      </div>
      <div class="column">
        {{ doc.filename }}
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth label">
        File size
      </div>
      <div class="column">
        {{ fileSize(doc.data.size) }}
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth label">
        Page count
      </div>
      <div class="column">
        {{ doc.data.page_count }}
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth label">
        Title
      </div>
      <div class="column">
        {{ doc.title }}
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth label">
        Artist
      </div>
      <div class="column">
        {{ doc.data.artist }}
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth label">
        Label
      </div>
      <div class="column">
        <b-tag v-if="doc.data.label" type="is-info">
          {{ doc.data.label.name }}
        </b-tag>
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth label">
        Territories
      </div>
      <div class="column">
        <b-tag v-for="t in doc.data.territories" :key="t.id" type="is-info">
          {{ t.name }}
        </b-tag>
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth label">
        Uploader
      </div>
      <div class="column">
        {{ doc.data.uploader.first_name }} {{ doc.data.uploader.last_name }}
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth label">
        Thumbnail
      </div>
      <div class="column">
        <img alt="thumbnail" :src="doc.thumbnail_url" />
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth label">
        Change status to:
      </div>
      <div class="column">
        <button class="button tag is-danger" v-on:click="fail" type="is-danger">
          Failed
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'
import parseISO from "date-fns/parseISO"
import filesize from 'filesize'
import {failDocument} from '@/api'

export default {
  name: "DocumentDetailsInfo",
  props: {
    doc: { type: Object, required: true }
  },
  methods: {
    fail: async function () {
      try{
      const doc = this.$props.doc
      await failDocument(doc.cirrus_id)
        this.$buefy.toast.open(`Failed document`)
      }catch{
        this.$buefy.toast.open(`Error, did not fail document`)


      }
    },
    formatDate (dateStr) {
      const dt = parseISO(dateStr)
      return format(dt, 'yyy-MM-dd HH:mm:ss')
    },
    fileSize (size) {
      return filesize(size)
    }
  }
}
</script>


<style>
.no-data-error {
  opacity: 0.5;
}
.detail-list .label {
  text-align: right;
}
</style>
